module.exports = __webpack_public_path__ + "assets/kids/img/logo-cjf.a28de34e.png";